export default [
  // 钱包
  {
    path: '/wallet-info',
    name: 'WalletInfo',
    component: () => import('@/upgrade-page/views/wallet/index'),
    meta: {
      needLogin: true,
      pageWidth: 980,
    },
  },
  // 個人信息
  {
    path: '/user-info',
    name: 'UserInfo',
    component: () => import('@/upgrade-page/views/user-info'),
    meta: {
      needLogin: true,
    },
  },
  // 設置
  {
    path: '/user-set',
    name: 'UserSet',
    component: () => import('@/upgrade-page/views/user-set/index'),
    redirect: '/user-set/account',
    children: [
      // 设置登录账户信息
      {
        path: '/user-set/account',
        name: 'SetAccount',
        component: () => import('@/upgrade-page/views/user-set/account'),
        meta: {
          needLogin: true,
          pageWidth: 980,
        },
      },
      // 设置拉黑名单
      {
        path: '/user-set/black',
        name: 'SetBlack',
        component: () => import('@/upgrade-page/views/user-set/black'),
        meta: {
          needLogin: true,
          pageWidth: 980,
        },
      },
      // 设置通知
      {
        path: '/user-set/notice',
        name: 'SetNotice',
        component: () => import('@/upgrade-page/views/user-set/notice'),
        meta: {
          needLogin: true,
          pageWidth: 980,
        },
      },
    ]
  },
  // 會員中心
  {
    path: '/vip-center',
    name: 'VipCenter',
    component: () => import('@/upgrade-page/views/vip-center'),
    meta: {
      needLogin: true,
      hideNav: true,
      pageWidth: '100%',
    },
  },
]
